import { defaultProperties } from '@Renderer/texturepacks/Links.js';
import { getTextures, getObjects } from "./Base.js"

let proeprties = defaultProperties
proeprties.contrastRoughness = 0.7
let copy = getTextures(proeprties)
let skipResize = ['waterSurface', 'sheetmetal', 'tarpaper']
for (let key in copy) {
	if(key == 'sheetmetal' || key == 'tarpaper')  {
		for(let option of copy[key].compileOptions.diffuse){
			if(option.name === 'filter') {
				option.disabled = false
			}
		}
	}
	if(skipResize.includes(key)) {
		//copy[key].size *= 5
		//copy[key].size /= 2
	} else {
		copy[key].size *= 1.2
	}
	if(key === 'fairway') {
		for(let option of copy[key].compileOptions.diffuse){
			if(option.name === 'overlay') {
				option.scale /= 1.2
			}
		}

	}
}
export const Textures = copy
